import Vue from "vue";

function transformer(data) {
  return {
    quantity: +data.quantity,
    price: +data.price,
    comment: data.comment,
    quantification_concept: data.conceptId,
    supply: data.supply,
  };
}

export default (payload) => {
  const dataTransformed = transformer(payload);

  return Vue.$http.post(
    "purchase/add-supplies-to-quantification-from-catalog/",
    dataTransformed
  );
};



// WEBPACK FOOTER //
// ./src/services/purchase/addSupplyToConcept.js